import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    Avatar,
    Chip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

function AktivitaetTab({ stats }) {
    return (
        <Grid container spacing={3}>
            <Grid>
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Trainingsaktivität (letzte 30 Tage)
                        </Typography>
                        <Divider sx={{ my: 2 }} />
                        {stats?.aktivitaet?.length > 0 ? (
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Mitglied</TableCell>
                                            <TableCell align="right">Trainings</TableCell>
                                            <TableCell align="right">Trainingstage</TableCell>
                                            <TableCell align="right">Gesamt Sätze</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stats.aktivitaet.map((a) => (
                                            <TableRow key={a.id}>
                                                <TableCell>
                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
                                                            {a.vname.charAt(0)}
                                                        </Avatar>
                                                        <Typography variant="body2">
                                                            {a.vname} {a.nname}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Chip label={a.anzahl_trainings || 0} size="small" color="primary" />
                                                </TableCell>
                                                <TableCell align="right">{a.trainingstage || 0}</TableCell>
                                                <TableCell align="right">{a.gesamt_saetze || 0}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                                Noch keine Aktivitäten
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </Grid>

            {/* Beliebteste Übungen */}
            <Grid>
                <Card>
                    <CardContent>
                        <Box display="flex" alignItems="center" mb={2}>
                            <Avatar sx={{ bgcolor: 'secondary.main', mr: 2 }}>
                                <FitnessCenterIcon />
                            </Avatar>
                            <Typography variant="h6">Beliebteste Übungen</Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        {stats?.beliebteUebungen?.length > 0 ? (
                            <Grid container spacing={2}>
                                {stats.beliebteUebungen.map((u, idx) => (
                                    <Grid key={idx}>
                                        <Card variant="outlined" sx={{ bgcolor: 'background.default' }}>
                                            <CardContent>
                                                <Typography variant="body1" fontWeight={600} gutterBottom>
                                                    {u.uebung_name}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                                                    {u.zielmuskel} • {u.kategorie}
                                                </Typography>
                                                <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                                                    <Chip label={`${u.anzahl_nutzer} Nutzer`} size="small" variant="outlined" />
                                                    <Chip label={`Ø ${parseFloat(u.durchschnitt_gewicht).toFixed(1)}kg`} size="small" color="primary" />
                                                    <Chip label={`Max ${u.max_gewicht}kg`} size="small" color="secondary" />
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                                Noch keine Daten
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

export default AktivitaetTab;
